import { apiDelete } from "../baseApi";

export const deleteForDistrict = async (id,data={}, cancelToken = null) => {
  try {
    const response = await apiDelete("_userDistrict", id, data, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
